import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { CatalogService } from '../../catalog.service';
import { ToastrService } from 'ngx-toastr';
import { FileInputComponent } from '@root/common/file-input/file-input';
import {
  MAX_FILE_SIZE,
  Maximum_file_size_540kb,
  format_not_allowed,
} from '@root/app.constant';
import { IapData, BlogData , BannerData, VideoData, InfographicData, Blog, TextData} from '../catalogue-iap-page.model';
import { EditorConfig } from '@root/app.constant';


@Component({
  selector: 'app-catalouge-add-iap-content',
  templateUrl: './catalouge-add-iap-content.component.html',
  styleUrls: ['./catalouge-add-iap-content.component.scss']
})
export class CatalougeAddIAPContentComponent implements OnInit , OnChanges{

  // iapData = new IapData()
  @Input() iapData: IapData;
  @Output() refreshChange = new EventEmitter<string>();

  @ViewChild('f', { static: false }) form: NgForm;
  sections: any[];
  subSections:any[];
  file: File
  mobileFile: File
  infographicImage:File
  infographicThumbanil:File
  @ViewChild(FileInputComponent, { static: false }) fileInputComponent: FileInputComponent;
  fileName:  string | null = null;;
  mobfileName:  string | null = null;
  infographicImageName: string | null = null;;
  infographicThumbnailName: string | null = null;;
  editorConfig = EditorConfig;
  articleThumbnailName: string | null = null;;
  articleThumbnail:File
  articlesArray: Blog[] = [];
  selectedValue: any;
 videoThumbnailName: string | null = null;
  videoThumbanil:File
  // selectedValues:any[] =[]
  @Input() getSimilarAticleFlag:boolean




  constructor(private catalogService: CatalogService, private toastr: ToastrService) { }

  ngOnInit() {
    this.getSectionList()

  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.getSimilarAticleFlag ) { 
      if(this.iapData.subsectionName==='Text'){
        this.resetTextForm()
      }
      else{
        this.resetForm()
      }
    }
  }
  getSectionList() {
    this.catalogService.getSectionList().subscribe((resp) => {
      if (resp.status === 0) {
        this.sections = resp.data.subSectionData['IAP Page']
        this.iapData['subsectionName'] = this.sections[0].subSectionName
        this.refreshChange.emit('Banners')

      }
      else {
        this.toastr.error(resp.error.errorMessage);
      }
    },

      (error) => {
        this.toastr.error(error.errorMessage);

      })
 

  }



  public onFileChange(file: File, source: string) {
    let targetFile: any;
    let targetFileName: any;
  
    if (source === 'desktop') {
      targetFile = () => (this.file = file);
      targetFileName = () => (this.fileName = file ? file.name : null);
    } else if (source === 'mobile') {
      targetFile = () => (this.mobileFile = file);
      targetFileName = () => (this.mobfileName = file ? file.name : null);
    } else if (source === 'infoImage') {
      targetFile = () => (this.infographicImage = file);
      targetFileName = () => (this.infographicImageName = file ? file.name : null);
    } else if (source === 'infoThumbnail') {
      targetFile = () => (this.infographicThumbanil = file);
      targetFileName = () => (this.infographicThumbnailName = file ? file.name : null);
    }  else if (source === 'videoThumbnail') {
      targetFile = () => (this.videoThumbanil = file);
      targetFileName = () => (this.videoThumbnailName = file ? file.name : null);
    }
     else if (source === 'articleThumbnail') {
      targetFile = () => (this.articleThumbnail = file);
      targetFileName = () => (this.infographicThumbnailName = file ? file.name : null);
    } else if (source === 'cardFileName0') {
    
        targetFile = () => (this.iapData.textData.subSections[0].icon = file);
        targetFileName = () =>
          (this.iapData.textData.subSections[0].iconPath = file ? file.name : null);
      
    } else if (source === 'cardFileName1') {
   
        targetFile = () => (this.iapData.textData.subSections[1].icon = file);
        targetFileName = () =>
          (this.iapData.textData.subSections[1].iconPath = file ? file.name : null);
      
    } else if (source === 'cardFileName2') {

        targetFile = () => (this.iapData.textData.subSections[2].icon = file);
        targetFileName = () =>
          (this.iapData.textData.subSections[2].iconPath = file ? file.name : null);
      
    } else {
      console.error(`Unknown source: ${source}`);
      return;
    }
  
    // Assign file to the property if defined
    if (targetFile) targetFile();
  
    // Validate image if file exists
    if (file) {
      this.validateImage(file, source);
    } else if (targetFileName) {
      targetFileName(); // Set filename to null
    }

  }
 

  private validateImage(file: File, source: String) {
    let isValid = true;
    const fsize = file.size;
    if (fsize > MAX_FILE_SIZE) {
      this.toastr.error(Maximum_file_size_540kb);
      isValid = false;
      this.clearFileComponent(file, source);
    } else if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
      this.toastr.error(format_not_allowed);
      isValid = false;
      this.clearFileComponent(file, source);
    }
  }

  private clearFileComponent(file: File, source: String) {
    if (this.fileInputComponent) {
      this.fileInputComponent.clear();
      this.file = null;
      setTimeout(() => {
        if(source === 'infoImage'){
         this.infographicImageName = null
        }
        else if(source==='infoThumbnail'){
          this.infographicThumbnailName= null;
        }
        else if(source==='videoThumbnail'){
            this.videoThumbnailName= null;
        }
        else if(source==='desktop'){
          this.fileName = null;
        }
        else if(source==='mobile'){
          this.mobfileName = null;
        }
        else if(source==='infoThumbnail'){
          this.articleThumbnailName = null;
        }
        else if(source === 'cardFileName0'){
          this.iapData.textData.subSections[0].iconPath = null
        }
        else if(source === 'cardFileName1'){
          this.iapData.textData.subSections[1].iconPath = null
        }
        else if(source === 'cardFileName2'){
          this.iapData.textData.subSections[2].iconPath = null
        }
    
      });
    }
  }

  public processData(displayOrder?: string) {
    this.iapData.subsectionId = this.findSubsectionId(this.iapData.subsectionName);
    if(this.iapData.subsectionName==='Text'){
      this.iapData.textData.sectionId = this.findSubsectionId(this.iapData.textData.sectionName);
    }
    switch (this.iapData.subsectionName) {
      case 'Banners':
        this.handleBannerData();
        break;
      case 'Videos':
        this.handleVideoData();
        break;
      case 'Infographics':
        this.handleInfographicData();
        break;
      case 'Articles':
        this.handleArticleData();
        break;
      case 'Text':
        this.handleTextData();
        break;
      default:
        console.error('Invalid subsection name');
    }
  }
  
  findSubsectionId(subsectionName: string): string {
    if(this.iapData.subsectionName==='Text'){
      const matchedTeam = this.subSections.find(
        ele =>
          ele.sectionName &&
          subsectionName &&
          ele.sectionName.trim().toLowerCase() === subsectionName.trim().toLowerCase()
      );
      return matchedTeam ? matchedTeam.id.toString() : '';
    }else{
      const matchedTeam = this.sections.find(
        ele =>
          ele.subSectionName &&
          subsectionName &&
          ele.subSectionName.trim().toLowerCase() === subsectionName.trim().toLowerCase()
      );
      return matchedTeam ? matchedTeam.id.toString() : '';
    }
   
  }
  
  private handleBannerData() {
    this.iapData.bannerData.bannerImage = this.fileName;
    this.iapData.bannerData.mobbannerImage = this.mobfileName;
  
    const formData = this.prepareBannerFormData();
    this.submitBannerData(formData);
  }
  
  private prepareBannerFormData(): FormData {
    const formData = new FormData();
    formData.append('source', 'W');
    formData.append('clickableUrl', this.iapData.bannerData.clickableUrl.toString())
    formData.append('subsectionId', this.iapData.subsectionId.toString());
    formData.append('sequence', this.iapData.bannerData.sequence.toString());
    if (this.iapData.id) formData.append('id', this.iapData.id.toString());
    formData.append('bannerImage', this.file || null);
    formData.append('mobileBannerImage', this.mobileFile || null);
    return formData;
  }
  
  private submitBannerData(formData: FormData) {
    const request = this.iapData.id
      ? this.catalogService.updateBanner(formData)
      : this.catalogService.addBanner(formData);
  
    request.subscribe(
      (resp) => this.handleResponse(resp),
      (err) => this.toastr.error(err.errorMessage)
    );
  }
  
  private handleVideoData() {
    // const data = {
    //   title: this.iapData.videoData.title,
    //   youtubeLink: this.iapData.videoData.youtubeLink,
    //   subsectionId: this.iapData.subsectionId,
    //   id: this.iapData.id || undefined,
    // };
    this.iapData.videoData.imagePath = this.videoThumbnailName;
    const formData = new FormData();
    formData.append('source', 'W');
    formData.append('title', this.iapData.videoData.title.toString());
    formData.append('youtubeLink', this.iapData.videoData.youtubeLink.toString());
    formData.append('subsectionId', this.iapData.subsectionId.toString());
    if (this.iapData.id) formData.append('id', this.iapData.id.toString());
    formData.append('thumbnail', this.videoThumbanil || null);
  
  
    this.catalogService.addOrUpdateVideo(formData).subscribe(
      (resp) => this.handleResponse(resp),
      (err) => this.toastr.error(err.errorMessage)
    );

    
  }
  
  private handleInfographicData() {
    this.iapData.infoData.filePath = this.infographicImageName;
    this.iapData.infoData.thumbnailPath = this.infographicThumbnailName;
  
    const formData = this.prepareInfographicFormData();
    this.submitInfographicData(formData);
  }
  
  private prepareInfographicFormData(): FormData {
    const formData = new FormData();
    formData.append('source', 'W');
    formData.append('subsectionId', this.iapData.subsectionId.toString());
    if (this.iapData.id) formData.append('id', this.iapData.id.toString());
    formData.append('image', this.infographicImage || null);
    formData.append('thumbnail', this.infographicThumbanil || null);
    return formData;
  }
  
  private submitInfographicData(formData: FormData) {
    const request = this.iapData.id
      ? this.catalogService.addOrUpdateInfographic(formData)
      : this.catalogService.addOrUpdateInfographic(formData);
  
    request.subscribe(
      (resp) => this.handleResponse(resp),
      (err) => this.toastr.error(err.errorMessage)
    );
  }
  
  private handleArticleData() {
    this.iapData.blogData.imagePath = this.articleThumbnailName; 
    const formData = this.prepareArticleFormData();
    this.submitArticleData(formData);
  }
  
  private prepareArticleFormData(): FormData {
    const formData = new FormData();
    formData.append('title', this.iapData.blogData.title);
    formData.append('content', this.iapData.blogData.content.toString());
    formData.append('subsectionId', this.iapData.subsectionId.toString());
    if(this.iapData.blogData.similarArticles && this.iapData.blogData.similarArticles.length>0){
      const similarArticleIds = this.iapData.blogData.similarArticles.map(blog => blog.id).join(", ")
      formData.append('similarArticles', similarArticleIds);
    }
    else{
      formData.append('similarArticles', null);
    }
    if (this.iapData.id) formData.append('id', this.iapData.id.toString());
    formData.append('thumbnail', this.articleThumbnail || null);
    return formData;
  }
  
  private submitArticleData(formData: FormData) {
    const request = this.iapData.id
      ? this.catalogService.addOrUpateArticle(formData)
      : this.catalogService.addOrUpateArticle(formData);
  
    request.subscribe(
      (resp) => this.handleResponse(resp),
      (err) => this.toastr.error(err.errorMessage)
    );
  }
  
  private handleTextData(){
    switch (this.iapData.textData.sectionName) {
      case 'Section1':
        this.handleSection1Data();
        break;
      case 'Section2':
        this.handleSection2Data();
        break;
      case 'Section3':
        this.handleSection2Data();
        break;
      case 'Form':
        this.handleSection1Data();
        break;
      case 'Disclaimer':
        this.handleDesclaimerData()
        break;
      default:
        console.error('Invalid subsection name');
    }
  }
  handleSection1Data(){
    const formData =this.prepareSection1FormData()
    this.submitSection1Data(formData)
  }

  prepareSection1FormData(){  
    const formData = new FormData();
    formData.append('title', this.iapData.textData.title);
    formData.append('description', this.iapData.textData.description);
    if (this.iapData.id) formData.append('id', this.iapData.id.toString());
    formData.append('sectionId', this.iapData.textData.sectionId);
    formData.append('sectionName', this.iapData.textData.sectionName);
    return formData;
  }

  private submitSection1Data(formData: FormData){
    const request = this.iapData.id
    ? this.catalogService.addOrEditIapPageText(formData)
    : this.catalogService.addOrEditIapPageText(formData);

  request.subscribe(
    (resp) => this.handleResponse(resp),
    (err) => this.toastr.error(err.errorMessage)
  );
  }

  handleSection2Data(){
    const formData =this.prepareSection1FormData()
    formData.append('subSections[0].title', this.iapData.textData.subSections[0].title);
    formData.append('subSections[0].description', this.iapData.textData.subSections[0].description);
    formData.append('subSections[0].icon', this.iapData.textData.subSections[0].icon);
    formData.append('subSections[1].title', this.iapData.textData.subSections[1].title);
    formData.append('subSections[1].description', this.iapData.textData.subSections[1].description);
    formData.append('subSections[1].icon', this.iapData.textData.subSections[1].icon);
    formData.append('subSections[2].title', this.iapData.textData.subSections[2].title);
    formData.append('subSections[2].description', this.iapData.textData.subSections[2].description);
    formData.append('subSections[2].icon', this.iapData.textData.subSections[2].icon);
    if(this.iapData.id){
  formData.append('subSections[0].id', this.iapData.textData.subSections[0].id);
    formData.append('subSections[1].id',this.iapData.textData.subSections[1].id);
    formData.append('subSections[2].id', this.iapData.textData.subSections[2].id);
    }
    formData.append('subSections[0].sequence', this.iapData.textData.subSections[0].sequence.toString());
    formData.append('subSections[1].sequence', this.iapData.textData.subSections[1].sequence.toString());
    formData.append('subSections[2].sequence', this.iapData.textData.subSections[2].sequence.toString());
    this.submitSection1Data(formData)
  }

  handleDesclaimerData(){
    const formData = this.prepareSection1FormData()
    formData.append('mobile', this.iapData.textData.mobile);
    formData.append('email', this.iapData.textData.email);  
    formData.append('disclaimerAdditionalText', this.iapData.textData.disclaimerAdditionalText);
    this.submitSection1Data(formData)

  }
  private handleResponse(resp: any) {
    if (resp.status === 0) {
      this.toastr.success(resp.message);
      this.iapData.id=''
      this.iapData.subsectionId =''

      if(this.iapData.subsectionName ==='Text'){
        this.refreshChange.emit(this.iapData.textData['sectionName']);
        this.resetTextForm()
      }
      else{
        this.refreshChange.emit(this.iapData.subsectionName);
        this.resetForm();
      }
    } else {
      this.toastr.error(resp.error.errorMessage);
      if(this.iapData.subsectionName ==='Text'){
        this.resetTextForm()
      }
      else{
        this.resetForm();
      }
    }
  }
  
  

  allowOnlyNumbers(event: KeyboardEvent): void {
    const charCode = event.charCode || event.keyCode;
    // Allow only numbers (0-9)
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }
  public resetForm() {
    if (this.form && this.iapData.subsectionName === "Banners") {
      this.form.resetForm({ section: this.sections[0].subSectionName });
    }
    else if (this.form && this.iapData.subsectionName === "Videos") {
      this.form.resetForm({ section: this.sections[1].subSectionName });

    }
    else if (this.form && this.iapData.subsectionName === "Infographics") {
      this.form.resetForm({ section: this.sections[2].subSectionName });

    }
    else if (this.form && this.iapData.subsectionName === "Articles") {
      this.form.resetForm({ section: this.sections[3].subSectionName });
      this.getSimilarArticleList()

    }
    else if(this.form && this.iapData.subsectionName === "Text"){
      this.form.resetForm({ section: this.sections[4].subSectionName });
    }

  }

  onSectionChange(selectedValue: string): void {
    this.resetForm()
    this.refreshChange.emit(selectedValue)
    this.iapData.id = ''
    this.iapData.infoData = new InfographicData()
    this.iapData.videoData = new VideoData()
    this.iapData.blogData = new BlogData()
    this.iapData.bannerData = new BannerData()
    this.iapData.textData = new TextData()
    this.iapData.textData.subSections = this.iapData.textData.subSections.map(card => ({
      ...card,
    }));

    
   if(selectedValue ==='Text'){
    this.catalogService.getIapPageTextSections().subscribe((resp) => {
      // resp ={
      //   "status": 0,
      //   "message": "Success",
      //   "data": {
      //     "referenceNo": "00315999",
         
      //       "list": [
      //         {
      //           "id": 1,
      //           "sectionName": "Section1"
      //         },
      //         {
      //           "id": 2,
      //           "sectionName": "Section2"
      //         },
      //         {
      //           "id": 3,
      //           "sectionName": "Section3"
      //         },
      //         {
      //           "id": 4,
      //           "sectionName": "Form"
      //         },
      //         {
      //           "id": 5,
      //           "sectionName": "Disclaimer"
      //         }
      //       ]
          
      //   }
      // }
      if (resp.status === 0) {
        this.subSections = resp.data['list']
        this.iapData.textData['sectionName'] = this.subSections[0].sectionName
        this.catalogService.setTextSubSections(this.subSections)
        this.refreshChange.emit('Section1')

      }
      else {
        this.toastr.error(resp.error.errorMessage);
      }
    },

      (error) => {
        this.toastr.error(error.errorMessage);

      })
   }
  

    // Add your logic here
  }
  onSubSectionChange(selectedValue: string): void{
    this.resetTextForm()
    this.iapData.id = ''
    this.refreshChange.emit(selectedValue)
  }
  
  resetTextForm(){

    if (this.form && this.iapData.textData.sectionName === "Section1") {
      this.form.resetForm({section: this.sections[4].subSectionName, subSection: this.subSections[0].sectionName });
    }
    else if (this.form && this.iapData.textData.sectionName === "Section2") {   
      this.form.resetForm({section: this.sections[4].subSectionName, subSection: this.subSections[1].sectionName });
    }
    else if (this.form && this.iapData.textData.sectionName == "Section3") {
      this.form.resetForm({ section: this.sections[4].subSectionName, subSection: this.subSections[2].sectionName });

    }
    else if (this.form && this.iapData.textData.sectionName === "Form") {
      this.form.resetForm({ section: this.sections[4].subSectionName, subSection: this.subSections[3].sectionName  });

    }
    else if(this.form && this.iapData.textData.sectionName === "Disclaimer"){
      this.form.resetForm({ section: this.sections[4].subSectionName, subSection: this.subSections[4].sectionName  });
    }
  }
  getSimilarArticleList(){
    this.iapData.blogData.similarArticles = [];
    this.selectedValue = '';
    this.catalogService.getArticles().subscribe((resp) => {
      if (resp.status === 0) {     
        this.articlesArray = resp.data.blogs.map((blog: any) => ({
          id: blog.id,
          title: blog.title
        }));

      }
      else {
        this.toastr.error(resp.error.errorMessage);
      }
    },

      (error) => {
        this.toastr.error(error.errorMessage);

      })
  }
  selectSimilar(value){
    this.selectedValue = value;
    if (this.selectedValue) {
      this.iapData.blogData.similarArticles = this.iapData.blogData.similarArticles || [];
      
      if (!this.iapData.blogData.similarArticles.some(article => article.id === this.selectedValue.id)) {
        this.iapData.blogData.similarArticles.push(this.selectedValue);
      }
    }
    this.selectedValue = '';
    
  }

  removeTitle(selectedArticleId: Blog) {
    if( this.iapData.blogData.similarArticles && this.iapData.blogData.similarArticles.length>0){
      this.iapData.blogData.similarArticles = this.iapData.blogData.similarArticles.filter(
        (article) => article.id !== selectedArticleId
    );
    }

  }
  
}
